module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('label', {
    staticClass: "label-form"
  }, [_vm._v(_vm._s(_vm.labelText))]), _vm._v(" "), _c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "lazy": "",
      "offset-y": "",
      "full-width": "",
      "transition": "scale-transition",
      "max-width": "290px",
      "nudge-left": 40
    },
    on: {
      "input": _vm.changeIconProduct
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', _vm._b({
    class: [_vm.bgIconBlue ? 'product-date-picker' : null],
    attrs: {
      "readonly": "",
      "single-line": "",
      "hide-details": "",
      "prepend-icon": _vm.icon,
      "label": _vm.labelText,
      "append-icon": _vm.arrowIconProduct,
      "append-icon-cb": _vm.toggleIconProductDate,
      "value": _vm.value
    },
    on: {
      "input": _vm.sendDate
    },
    slot: "activator"
  }, 'v-text-field', _vm.$attrs, false)), _vm._v(" "), _c('v-date-picker', _vm._b({
    attrs: {
      "no-title": "",
      "scrollable": "",
      "value": _vm.value
    },
    on: {
      "input": _vm.sendDate
    }
  }, 'v-date-picker', _vm.$attrs, false))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21f12c14","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/shared/select-date.vue
// module id = 941
// module chunks = 1 2 3 4 5 20 21 27 47